// src/pages/SettingsBIAccess.jsx

import React from 'react';
import BIAccessSection from '../components/BIAccessSection';
import { isAdmin } from '../utils/roles';

/**
 * Customer-facing BI Access management.
 *
 * Mounted at /settings/bi-access via Settings.jsx routes.
 *
 * Reads the user's role from localStorage to decide whether to show
 * mutating controls (provision/rotate/revoke). All security-relevant
 * decisions are enforced server-side; this gate is purely UX so
 * non-admins don't see buttons that would 403.
 */
export default function SettingsBIAccess() {
  const userCanMutate = isAdmin();

  return (
    <div className="flex-1 max-w-3xl">
      <h2 className="text-2xl font-semibold text-white mb-1">BI Access</h2>
      <p className="text-sm text-[#a0a0a0] mb-6">
        Manage direct database access for Power BI, Tableau, and other
        Postgres-compatible BI tools.
      </p>

      <BIAccessSection
        apiPrefix="/me/bi-access"
        canMutate={userCanMutate}
      />

      {/* Helpful context links section */}
      <div className="mt-6 p-4 bg-[#1a1a1a] rounded-lg border border-[#2a2a2a]">
        <h3 className="text-sm font-semibold text-white mb-2">
          How does this work?
        </h3>
        <ul className="text-sm text-[#a0a0a0] space-y-2 list-disc list-inside">
          <li>
            Connex provisions a read-only Postgres role scoped to your
            organization's data only.
          </li>
          <li>
            Use the credentials in any BI tool that connects to PostgreSQL:
            Power BI, Tableau, Looker, Metabase, DBeaver, Excel, and more.
          </li>
          <li>
            Your password is shown once and never stored. Lost it? Just rotate
            to a new one.
          </li>
          <li>
            All access is logged. Revoke any time to immediately cut off
            connected tools.
          </li>
        </ul>
      </div>
    </div>
  );
}